import React from 'react';
import {createRoot} from 'react-dom/client';
import styles from './styles.module.css';
import Home from './Home/index';
import HamburgerSvg from './HamburgerSvg';
import Menu from './Menu';
import Search from './Search/index';
// import RightItems from './RightItems';
// import PasswordBanner from './PasswordBanner';
import CookiesConsent from './CookiesConsent';
import GoToTopButton from './GoToTopButton';
import PodcastBanner from './PodcastBanner';
// import Banner from './Banner';
// import PasswordBanner from './PasswordBanner';

const Header = () => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <div className={styles.headerStatic} />
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <Home />
                    <Search />
                </div>
                <div className={styles.headerInner}>
                    {/* {!open && <RightItems items={items} />} */}
                    {!open && (
                        <HamburgerSvg
                            onClick={() => {
                                setOpen(!open);
                            }}
                        />
                    )}
                </div>
            </div>
            <PodcastBanner />
            <Menu
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
            />
            {/* <PasswordBanner /> */}
            <CookiesConsent />
            <GoToTopButton />
        </>
    );
};

export default () => {
    const domNode = document.getElementById('header');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(<Header />);
    }
};
